module.exports = __webpack_public_path__ + "static/1-919e418067abc0efd2bf7b71fda1cec6.png";